jQuery(function() {
	initFixedHeader();
});

function initFixedHeader() {
	var win = jQuery(window);

	jQuery('#wrapper').each(function(){
		var backBtn = jQuery(this);
		win.on('load scroll resize', function(){

			var offset = jQuery('.main').outerHeight();
			if (win.scrollTop() > 10) {
				backBtn.addClass('header-fixed');
			}else{
				backBtn.removeClass('header-fixed');
			}
		});
	});
}